import { f as formatMoney } from './currency-BS0riN3f.js';

class ProductPrice extends HTMLElement {
  hasPopularAddOns = this.hasAttribute('data-synced-with-product-add-ons') || false;

  connectedCallback() {
    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handlePriceChange(html);
        if (this.hasPopularAddOns && window.popularAddOns.length > 0) {
          const addOnValue = parseInt(
            window.popularAddOns.reduce((total, item) => total + item.price, 0)
          );
          this.updatePriceWith(addOnValue);
        }
      }
    );

    // Make sure the product is a add-on
    if (!this.hasPopularAddOns) return;

    this.unsubscribePriceChanged = subscribe(`price:changed:product-add-ons`, ({ cents }) => {
      this.savedCents = cents;
      this.updatePriceWith(cents);
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    if (this.hasPopularAddOns) {
      this.unsubscribePriceChanged();
    }
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const productPrice = html.querySelector('product-price');
    this.innerHTML = productPrice.innerHTML;
  }

  updatePriceWith(cents) {
    // Only update the price if the cents are set in the data attribute
    if (!this.dataset.cents) return;

    this.querySelector('[data-current-price]').textContent = formatMoney(
      cents + parseInt(this.dataset.cents),
      window.SHOP_MONEY_FORMAT
    );
  }
}

customElements.define('product-price', ProductPrice);
